import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavigationHeader.css';

const NavigationHeader: React.FC = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className={`nav-header ${isScrolled ? 'scrolled' : ''} ${isHomePage ? 'home' : ''}`}>
            <div className="nav-container">
                <Link to="/" className="nav-logo">
                    <span className="logo-text">MailMeld</span>
                </Link>

                <nav className="nav-links">
                    <a href="#features" className="nav-link">Features</a>
                    <a href="#how-it-works" className="nav-link">How It Works</a>
                    <a href="#benefits" className="nav-link">Benefits</a>

                    <a
                        href="YOUR_GOOGLE_WORKSPACE_MARKETPLACE_LINK_HERE"
                        className="nav-button"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Install Now
                    </a>
                </nav>
            </div>
        </header>
    );
};

export default NavigationHeader;